import { leads } from './role'

export const queries = {
  leads,
}
export default queries
